import PointsShop from './PointsShop'

export default PointsShop
